import Vue from 'vue';

import { library } from '@fortawesome/fontawesome-svg-core'
import { faBookmark as fasBookmark, faColumns, faGlobe, faPhone, faLink, faUnlink, faTrashAlt, faHistory, faUserSecret, faThLarge, faChartPie, faBars, faSlidersH, faSignOutAlt, faTimesCircle, faPlusCircle, faMinusCircle, faArrowAltCircleLeft, faArrowAltCircleRight, faChevronLeft, faChevronRight, faSave, faTimes, faExternalLinkAlt, faEdit, faExclamationCircle, faLessThan, faGreaterThan, faEquals, faCar, faUserTie, faTags, faEllipsisV, faCopy, faHouseDamage, faCheckCircle, faSpinner, faCloudDownloadAlt } from '@fortawesome/free-solid-svg-icons'
import { faBookmark as farBookmark, faBell, faQuestionCircle, faUser, faEnvelope, faEnvelopeOpen } from '@fortawesome/free-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

library.add(faUserSecret)
library.add(faHistory)
library.add(faThLarge)
library.add(faChartPie)
library.add(faBars)
library.add(faSlidersH)
library.add(faBell)
library.add(faQuestionCircle)
library.add(faSignOutAlt)
library.add(faPlusCircle)
library.add(faMinusCircle)
library.add(faArrowAltCircleLeft)
library.add(faArrowAltCircleRight)
library.add(faChevronLeft)
library.add(faChevronRight)
library.add(faSave)
library.add(faTimes)
library.add(faExternalLinkAlt)
library.add(faEdit)
library.add(faExclamationCircle)
library.add(faLessThan)
library.add(faGreaterThan)
library.add(faEquals)
library.add(faTrashAlt)
library.add(faTags)
library.add(faEllipsisV)
library.add(faCopy)
library.add(faHouseDamage)
library.add(faUserTie)
library.add(faCar)
library.add(faTrashAlt)
library.add(faUser)
library.add(faEnvelope)
library.add(faEnvelopeOpen)
library.add(faLink)
library.add(faPhone)
library.add(faGlobe)
library.add(fasBookmark)
library.add(farBookmark)
library.add(faUnlink)
library.add(faColumns)

library.add(faCheckCircle)
library.add(faTimesCircle)
library.add(faSpinner)

library.add(faCloudDownloadAlt)

Vue.component('b-icon', FontAwesomeIcon)
